module.exports = __webpack_public_path__ + "img/uranus.be5030ca.webp";